(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('wsCardList', ['Card', 'CardGroup', '$rootScope', 'CardRegistry', '$timeout', 'wsEventNames', '$q', '$filter', 'CardUtils', 'Demo', 'AppPermissions', 'UserRoles', 'ViewDashboardsAs', 'User', function (Card, CardGroup, $rootScope, CardRegistry, $timeout, wsEventNames, $q, $filter, CardUtils, Demo, AppPermissions, UserRoles, ViewDashboardsAs, User) {
    return {
      scope: {
        cfg: '=?'
      },
      templateUrl: "modules/common/directives/card-list/card-list.html",
      link: function link($scope) {
        $scope.search = {};
        $scope.cards = [];
        $scope.limit = 10;
        $scope.offset = 0;
        $scope.isDemo = Demo.isDemoMode();
        var initialLoad = false;
        CardGroup.get($scope.cfg.boardId).then(function (cardGroup) {
          if (cardGroup === null) {
            return;
          }
          CardRegistry.multiGet(cardGroup.cardIds).then(function (cards) {
            $scope.cards = _.chain(cards).filter(function (card) {
              return !card.hidden;
            }).value();
            $scope.$broadcast(wsEventNames.pager.setPage, 1);
            initialLoad = true;
          });
        });
        $scope.sortDirection = {};
        $scope.sort = function sort(s) {
          var dir = $scope.sortDirection[s] === 'up' ? 'down' : 'up';
          $scope.sortDirection = {};
          $scope.sortDirection[s] = dir;
          $scope.cards = _.sortBy($scope.cards, s);
          if (dir === 'down') {
            $scope.cards.reverse();
          }
        };
        $scope.getCardUrl = CardUtils.getCardUrl;
        AppPermissions.getForUser({
          value: 'explorer'
        }).then(function (permissions) {
          $scope.exposeExplorerLink = (permissions.length || UserRoles.isExploreAllowed(User.get())) && !UserRoles.isConsultant(User.get()) && !ViewDashboardsAs.isActive;
        });
        $scope.edit = function (card) {
          CardRegistry.add(card);
          $rootScope.$broadcast("explore-card", {
            cardId: card.id
          });
        };
        $scope.delete = function (id) {
          Card.remove(id).then(function () {
            var idx = _.findIndex($scope.cards, {
              id: id
            });
            $scope.cards.splice(idx, 1);
          });
        };
        $scope.fetchCardPage = function (offset, limit) {
          $scope.limit = limit || 10;
          $scope.offset = offset || 0;
          var defer = $q.defer();
          defer.resolve({
            count: $filter('filter')($scope.cards, $scope.search).length
          });
          return defer.promise;
        };
        $scope.$watch('search.title', function () {
          if (initialLoad) {
            $scope.$broadcast(wsEventNames.pager.setPage, 1);
          }
        });
      }
    };
  }]);
})();
